// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__JzELo","spinner":"Loader_spinner__4LJAs"};